import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SkeletonBlockComponent } from '../skeleton/skeleton-block/skeleton-block.component';

export interface BreadcrumbItem {
  label: string;
  routerLink?: string | string[];
}

@Component({
  selector: 'xemex-breadcrumb',
  standalone: true,
  imports: [RouterModule, MatIconModule, SkeletonBlockComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './breadcrumb.component.scss',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  items = input.required<BreadcrumbItem[]>();
  loading = input<boolean>(false);
}
